import { render, staticRenderFns } from "./SetupDelivery.vue?vue&type=template&id=c8807378&"
import script from "./SetupDelivery.vue?vue&type=script&lang=js&"
export * from "./SetupDelivery.vue?vue&type=script&lang=js&"
import style0 from "./SetupDelivery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports